// Move TOC to Sidebar and Add Smooth Scroll
document.addEventListener('DOMContentLoaded', function() {
  const toc = document.querySelector('.article--content .blog-toc-wrapper');
  const sidebar = document.querySelector('.toc-sticky-container');
  
  if (toc && sidebar) {
    sidebar.appendChild(toc);
  }
  
  // Smooth scroll for TOC links
  const tocLinks = document.querySelectorAll('.blog-toc-wrapper a[href^="#"]');
  tocLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        const offset = 100;
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
});